import React from 'react';
import './SearchBar.css';

const SearchBar = ({ search, onSearchChange, selectedTag, onTagChange, tags, totalElements, totalCount, onReset }) => {
  return (
    <div className="search-bar">
      <input
        type="text"
        className="search-input"
        placeholder="ara: başlık, içerik /"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
      />

      <select
        className="search-select"
        value={selectedTag}
        onChange={(e) => onTagChange(e.target.value)}
      >
        <option value="">etiket: tümü</option>
        {tags.map(tag => (
          <option key={tag} value={tag}>{tag}</option>
        ))}
      </select>

      <span className="search-count">
        {totalElements} / {totalCount}
      </span>

      <button className="search-reset" onClick={onReset}>
        reset
      </button>
    </div>
  );
};

export default SearchBar;
